document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);

  let campaign = urlParams.get('campaign');
  if (!campaign) {
    return;
  }

  campaign = campaign.trim();

  if (campaign?.length) {
    const productForm = document.querySelector('.product-form form');

    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'attributes[_campaign]');
    input.setAttribute('value', campaign);
    productForm.appendChild(input);
  }
});